import React, { useMemo } from 'react'
import { makeStyles } from '@material-ui/styles'
import { ListItem, Button } from '@material-ui/core'
import { mutualTheme } from '~/utils/theme'
import { transparentize } from 'polished'
import { NavLink, useRouteMatch } from 'react-router-dom'

const useStyles = makeStyles({
  listItem: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  buttonLabel: {
    fontFamily: 'Airbnb',
    display: 'flex',
    textTransform: 'none',
    fontWeight: 'bold',
    justifyContent: 'flex-start',
    paddingLeft: mutualTheme.spacing(2)
  },
  button: {
    fontFamily: 'Airbnb',
    padding: mutualTheme.spacing(2),
    color: mutualTheme.palette.common.white,
    '&:hover': {
      color: transparentize(0.20, mutualTheme.palette.common.white),
      backgroundColor: transparentize(0.80, mutualTheme.palette.common.black)
    }
  },
  buttonActive: {
    backgroundColor: transparentize(0.80, mutualTheme.palette.common.black)
  },
  buttonActiveIcon: {
    color: mutualTheme.palette.primary.main
  },
  buttonInactiveIcon: {
    color: transparentize(0.80, mutualTheme.palette.common.white)
  }
})

export type SidebarExpandedButtonProps = {
  to?: string,
  startIcon: JSX.Element,
  onClose: () => void,
  onClick?: () => void
}

export const SidebarExpandedButton: React.FC<SidebarExpandedButtonProps> = (props) => {
  const { onClose, to, onClick, startIcon, children } = props
  const classes = useStyles()
  const match = useRouteMatch(to ? to : '')

  const isActive = useMemo(() => Boolean(match), [match])

  return (
    <ListItem>
      {to
        ? (
          <Button
            component={NavLink}
            {...props}
            to={to}
            onClick={onClick ? onClick : onClose}
            className={classes.button}
            classes={{
              text: classes.buttonLabel,
              startIcon: isActive && !onClick ? classes.buttonActiveIcon : classes.buttonInactiveIcon
            }}
            activeClassName={onClick ? '' : classes.buttonActive}
            fullWidth
          />
        )
        : (
          <Button
            onClick={onClick ? onClick : onClose}
            className={classes.button}
            classes={{
              text: classes.buttonLabel,
              startIcon: isActive && !onClick ? classes.buttonActiveIcon : classes.buttonInactiveIcon
            }}
            startIcon={startIcon}
            fullWidth
          >{children}</Button>
        )}
    </ListItem>
  )
}
